/**
 * The scopes the score series is offered at: the four that select from
 * comments (platform design §10.5) minus topic cluster, whose clusters no read route lists.
 * Segment and territory are never scopes of this series.
 */

import type { PostRow } from '../api/schemas';

export const SCOPE_KINDS = ['campaign', 'account', 'post'] as const;
export type ScopeKind = (typeof SCOPE_KINDS)[number];

/** The `scope_ref` the series is read at: the chosen account or post, or the
 *  whole campaign until one is chosen, so no read waits on a choice. */
export function scopeRefOf(kind: ScopeKind, ref: string, campaignId: string): string {
  return kind === 'campaign' || ref === '' ? campaignId : ref;
}

export interface AccountOption {
  id: string;
  label: string | null;
}

/** The accounts the campaign's posts came from, in first-seen order. */
export function accountsOf(posts: readonly PostRow[]): AccountOption[] {
  const seen = new Map<string, AccountOption>();
  for (const post of posts) {
    if (!seen.has(post.account_id)) {
      seen.set(post.account_id, { id: post.account_id, label: post.handle ?? post.label });
    }
  }
  return [...seen.values()];
}
